module.exports = __webpack_public_path__ + "assets/groceries-default-image-016589.svg";